(function () {
  'use strict';

  var CUSTOMER_ID = '8151';
  var SDK_URL = 'https://viewer-cdn.cylindo.com/v1/index.mjs';
  var PRECONNECT_URL = 'https://content.cylindo.com';
  var SDK_TIMEOUT_MS = 20000;
  var VIEWER_TIMEOUT_MS = 30000;
  var SPIN_STEP = 3; // frames per button press (~30° on a 36-frame viewer)

  var _sdkPromise = null;

  // Lazy-load the Cylindo SDK as an ES module; resolves when cylindo-viewer is defined.
  function loadSDK() {
    if (_sdkPromise) return _sdkPromise;

    _sdkPromise = new Promise(function (resolve, reject) {
      var preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = PRECONNECT_URL;
      preconnect.crossOrigin = '';
      document.head.appendChild(preconnect);

      var script = document.createElement('script');
      script.type = 'module';
      script.src = SDK_URL;
      script.addEventListener('error', function () {
        reject(new Error('[Cylindo 360] SDK script failed to load'));
      });
      document.head.appendChild(script);

      var timer = setTimeout(function () {
        reject(new Error('[Cylindo 360] SDK load timed out'));
      }, SDK_TIMEOUT_MS);

      customElements.whenDefined('cylindo-viewer').then(function () {
        clearTimeout(timer);
        resolve();
      });
    });

    return _sdkPromise;
  }

  // Converts {"UPHOLSTERY":"RUSH 440"} → "UPHOLSTERY:RUSH 440" for the configuration attribute.
  function featuresToConfiguration(features) {
    if (!features || typeof features !== 'object') return '';
    return Object.keys(features)
      .map(function (k) { return k + ':' + features[k]; })
      .join(',');
  }

  function Cylindo360(productId) {
    this.productId = productId;
    this.button = document.querySelector(
      '.product__cylindo-360-btn[data-cylindo-product="' + productId + '"]'
    );
    this.modal = document.getElementById('Cylindo360Modal-' + productId);
    this.viewerEl = null;
    this.currentVariantId = null;
    this._openerEl = null;
    this.variantData = this._parseVariantData();

    // Move to <body> to avoid z-index/fixed-position conflicts with the gallery.
    if (this.modal && this.modal.parentElement !== document.body) {
      document.body.appendChild(this.modal);
    }

    window.__cylindo360Instances = window.__cylindo360Instances || [];
    window.__cylindo360Instances.push(this);

    this._init();
  }

  Cylindo360.prototype._parseVariantData = function () {
    var el = document.getElementById('CylindoVariantData-' + this.productId);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent).variants || {};
    } catch (e) {
      return {};
    }
  };

  // Scoped to the MainProduct section to avoid matching quick-add forms.
  Cylindo360.prototype._findVariantInput = function () {
    var mainSection = this.button && this.button.closest('[id^="MainProduct-"]');
    if (!mainSection) return null;
    var form = mainSection.querySelector('[id^="product-form-"]');
    return (form && form.querySelector('[name="id"]')) ||
           mainSection.querySelector('[name="id"]');
  };

  // Re-reads the live form input; falls back to data-initial-variant.
  Cylindo360.prototype._syncVariantId = function () {
    var input = this._findVariantInput();
    if (input && input.value) {
      this.currentVariantId = parseInt(input.value, 10);
    } else if (this.button && this.button.dataset.initialVariant) {
      this.currentVariantId = parseInt(this.button.dataset.initialVariant, 10);
    }
  };

  Cylindo360.prototype._init = function () {
    this._syncVariantId();
    this._updateButtonVisibility();
    this._attachModalListeners();
    this._attachVariantListener();
    this._watchBreBage();
  };

  Cylindo360.prototype._getVariantData = function () {
    return this.currentVariantId ? (this.variantData[this.currentVariantId] || null) : null;
  };

  Cylindo360.prototype._updateButtonVisibility = function () {
    if (!this.button) return;
    var data = this._getVariantData();
    var show = !!(data && data.productCode) &&
               !(window.CylindoAB && window.CylindoAB.isHideVariant());
    this.button.classList.toggle('hidden', !show);
  };

  Cylindo360.prototype._attachModalListeners = function () {
    var self = this;

    if (this.button) {
      this.button.addEventListener('click', function () { self.open(); });
    }

    if (!this.modal) return;

    var closeBtn = this.modal.querySelector('.cylindo-360-modal__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

    var dialog = this.modal.querySelector('.cylindo-360-modal__dialog');
    document.addEventListener('pointerdown', function (e) {
      if (!self.modal.hidden && dialog && !dialog.contains(e.target)) {
        self.close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal && !self.modal.hidden) self.close();
    });

    this.modal.querySelectorAll('.cylindo-360-modal__spin-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._rotateBy(parseInt(btn.dataset.direction, 10) * SPIN_STEP);
      });
    });

    var fsBtn = this.modal.querySelector('.cylindo-360-modal__fullscreen');
    if (fsBtn) {
      if (document.fullscreenEnabled) {
        fsBtn.addEventListener('click', function () {
          if (!document.fullscreenElement) {
            dialog.requestFullscreen().catch(function (e) {
              console.warn('[Cylindo 360] requestFullscreen failed:', e);
            });
          } else {
            document.exitFullscreen();
          }
        });
      } else {
        fsBtn.hidden = true;
      }
    }
  };

  Cylindo360.prototype._watchBreBage = function () {
    if (!this.button) return;
    var btn = this.button;

    function apply() {
      btn.classList.add('product__cylindo-360-btn--bre-bage');
    }

    if (document.querySelector('.bre-bage')) {
      apply();
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('bre-bage') || node.querySelector('.bre-bage')) {
            apply();
            observer.disconnect();
            clearTimeout(timeout);
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Disconnect after 10s if the element never appears
    var timeout = setTimeout(function () { observer.disconnect(); }, 10000);
  };

  Cylindo360.prototype._attachVariantListener = function () {
    var self = this;

    // PubSub — primary; retries until the global is available.
    function attachPubSub() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          if (!variant) return;
          self.currentVariantId = variant.id;
          self._updateButtonVisibility();
          if (self.modal && !self.modal.hidden) self._updateViewer();
        });
      } else {
        setTimeout(attachPubSub, 100);
      }
    }
    attachPubSub();

    // Direct input change — fallback for timing edge cases.
    var variantInput = this._findVariantInput();
    if (variantInput) {
      variantInput.addEventListener('change', function () {
        var newId = parseInt(variantInput.value, 10);
        if (newId && newId !== self.currentVariantId) {
          self.currentVariantId = newId;
          self._updateButtonVisibility();
          if (self.modal && !self.modal.hidden) self._updateViewer();
        }
      });
    }
  };

  Cylindo360.prototype.open = function () {
    if (!this.modal) return;

    this._syncVariantId(); // use live selection, not cached init value
    this._openerEl = document.activeElement;
    this.modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    this._showState('loading');

    var self = this;
    loadSDK()
      .then(function () { return self._initViewer(); })
      .then(function () {
        var closeBtn = self.modal.querySelector('.cylindo-360-modal__close');
        if (closeBtn) closeBtn.focus();
      })
      .catch(function (err) {
        console.error(err);
        self._showState('error');
      });
  };

  Cylindo360.prototype.close = function () {
    if (!this.modal) return;
    if (document.fullscreenElement) document.exitFullscreen();
    this.modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (this._openerEl) this._openerEl.focus();
  };

  Cylindo360.prototype._initViewer = function () {
    var self = this;
    var data = this._getVariantData();

    if (!data || !data.productCode) {
      return Promise.reject(new Error('[Cylindo 360] No product code for current variant'));
    }

    // Tear down any previous viewer.
    if (this.viewerEl) {
      this.viewerEl.remove();
      this.viewerEl = null;
    }

    var container = this.modal.querySelector('.cylindo-360-modal__viewer');
    var viewer = document.createElement('cylindo-viewer');
    viewer.setAttribute('customer-id', CUSTOMER_ID);
    viewer.setAttribute('code', data.productCode);

    // Set configuration before appending so the viewer never flashes the wrong colour.
    var configStr = featuresToConfiguration(data.features);
    if (configStr) {
      viewer.setAttribute('configuration', configStr);
    }

    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        reject(new Error('[Cylindo 360] Viewer load timed out'));
      }, VIEWER_TIMEOUT_MS);

      function cleanup() { clearTimeout(timer); }

      viewer.addEventListener('loaded', function () {
        cleanup();
        self.viewerEl = viewer;
        try {
          var api = Object.getOwnPropertyNames(Object.getPrototypeOf(viewer))
            .filter(function (k) { return k !== 'constructor'; });
          console.log('[Cylindo 360] viewer API:', api.join(', '));
          console.log('[Cylindo 360] frame attr:', viewer.getAttribute('frame'), '| frame prop:', viewer.frame);
        } catch (e) {}

        // Shadow DOM fallback: hide AR button regardless of part name
        try {
          if (viewer.shadowRoot) {
            viewer.shadowRoot.querySelectorAll('[part]').forEach(function (el) {
              if (/view-in-ar/i.test(el.getAttribute('part') || '')) el.style.display = 'none';
            });
            viewer.shadowRoot.querySelectorAll('button').forEach(function (el) {
              if (/ar|augmented/i.test(el.getAttribute('aria-label') || '')) el.style.display = 'none';
            });
          }
        } catch (e) {}

        self._showState('viewer');
        resolve();
      }, { once: true });

      viewer.addEventListener('fallback', function (e) {
        cleanup();
        reject(new Error('[Cylindo 360] Viewer error: ' + (e.detail || '')));
      }, { once: true });

      container.appendChild(viewer);
    });
  };

  Cylindo360.prototype._updateViewer = function () {
    var self = this;
    var data = this._getVariantData();

    if (!data || !data.productCode) {
      this._showState('error');
      return;
    }

    // Same product code — swap configuration in-place.
    if (this.viewerEl && this.viewerEl.getAttribute('code') === data.productCode) {
      var configStr = featuresToConfiguration(data.features);
      if (configStr) {
        this.viewerEl.setAttribute('configuration', configStr);
      }
      return;
    }

    // Different product code — full reload.
    this._showState('loading');
    this._initViewer().catch(function (err) {
      console.error(err);
      self._showState('error');
    });
  };

  Cylindo360.prototype._showState = function (state) {
    var loading  = this.modal.querySelector('.cylindo-360-modal__loading');
    var error    = this.modal.querySelector('.cylindo-360-modal__error');
    var viewer   = this.modal.querySelector('.cylindo-360-modal__viewer');
    var controls = this.modal.querySelector('.cylindo-360-modal__spin-controls');

    if (loading)  loading.classList.toggle('hidden',  state !== 'loading');
    if (error)    error.classList.toggle('hidden',    state !== 'error');
    if (viewer)   viewer.classList.toggle('hidden',   state !== 'viewer');
    if (controls) controls.classList.toggle('hidden', state !== 'viewer');
  };

  Cylindo360.prototype._rotateBy = function (steps) {
    if (!this.viewerEl) return;
    try {
      var el = this.viewerEl;
      if (steps < 0 && typeof el.spinLeft  === 'function') { el.spinLeft(Math.abs(steps));  return; }
      if (steps > 0 && typeof el.spinRight === 'function') { el.spinRight(steps);            return; }
      var total   = typeof el.frames === 'number' ? el.frames : 36;
      var current = typeof el.frame  === 'number' ? el.frame
                  : parseInt(el.getAttribute('frame') || '0', 10) || 0;
      var next = ((current + steps) % total + total) % total;
      if (typeof el.goToFrame === 'function') { el.goToFrame(next); return; }
      if (typeof el.setFrame  === 'function') { el.setFrame(next);  return; }
      el.setAttribute('frame', String(next));
      el.frame = next;
    } catch (e) {
      console.warn('[Cylindo 360] _rotateBy failed:', e);
    }
  };

  function init() {
    document.querySelectorAll('.product__cylindo-360-btn[data-cylindo-product]').forEach(
      function (btn) { new Cylindo360(btn.dataset.cylindoProduct); }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Colour variant swap replaces the media wrapper HTML — tear down old instances and re-init.
  document.addEventListener('colorVariantChanged', function () {
    (window.__cylindo360Instances || []).forEach(function (instance) {
      if (instance.modal) {
        instance.close();
        instance.modal.remove();
      }
    });
    window.__cylindo360Instances = [];
    init();
  });
})();
